import * as tslib_1 from "tslib";
import { OnInit, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../../esri-loader-util';
import { LineStyleOptions, LineStyleOptionsForArcServer, LineStyleOptionsWithNull } from '../../../../selectionOptions';
import { LayerService } from '../../../../services/layer.service';
import { PrintService } from '../../../../services/print.service';
import { BaseSymbolEditorComponent } from '../baseSymbolEditor';
var Color;
var LineSymbolEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LineSymbolEditorComponent, _super);
    function LineSymbolEditorComponent(_vcr, printService, layerService) {
        var _this = _super.call(this, _vcr, layerService) || this;
        _this.printService = printService;
        _this.layerService = layerService;
        _this.lineStyleOptions = LineStyleOptions;
        _this.applyChange = function () {
            _this.lineSymbol.color = Color.fromRgb(_this.symbolColor);
            _this.lineSymbol.width = _this.lineWidth;
            _this.lineSymbol.style = _this.lineStyle;
            window.dispatchEvent(new CustomEvent('symbolChange', { detail: _this.uniqueLayerId }));
        };
        return _this;
    }
    Object.defineProperty(LineSymbolEditorComponent.prototype, "isLineStyleSupportedForPrinting", {
        get: function () {
            return this.printService.validateServerSideLayerStyle(this.lineStyle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LineSymbolEditorComponent.prototype, "replacementLineStyle", {
        get: function () {
            return this.printService.getSupportedLineStyle(this.lineStyle);
        },
        enumerable: true,
        configurable: true
    });
    LineSymbolEditorComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Color];
                    case 1:
                        Color = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LineSymbolEditorComponent.prototype, "layerType", {
        set: function (val) {
            if (val === 'map-image' || val === 'dynamic') {
                this.lineStyleOptions = LineStyleOptionsForArcServer;
            }
            else {
                this.lineStyleOptions = LineStyleOptionsWithNull;
            }
        },
        enumerable: true,
        configurable: true
    });
    LineSymbolEditorComponent.prototype.bindForm = function () {
        if (this.layerSymbol) {
            this.lineSymbol = this.layerSymbol;
            this.lineStyle = this.lineSymbol.style;
            this.lineWidth = this.lineSymbol.width;
            this.symbolColor = "rgba(" + this.lineSymbol.color.toRgba().join(', ') + ")";
            this.originalColor = this.symbolColor;
        }
    };
    return LineSymbolEditorComponent;
}(BaseSymbolEditorComponent));
export { LineSymbolEditorComponent };
